/* eslint-disable */
import ClipboardJS from 'clipboard';

(function() {
  function addEventListenerToArticleSummary() {
    const articleSummaryList = document.querySelectorAll('.article-summary');
    const containers = document.querySelectorAll('.article-summary-modal');

    if (articleSummaryList.length) {
      articleSummaryList.forEach((summary) => {
        const articleId = summary.dataset.id;
        summary.addEventListener('click', () => {
          const modal = document.querySelector(`[data-modal-id='${articleId}']`);
          modal.classList.add('is-open');
        });
      });
    }
    if (containers.length) {
      containers.forEach((modalContainer) => {
        modalContainer.addEventListener('click', (e) => {
          if (e.target.classList.contains('modal-backdrop')) {
            modalContainer.classList.remove('is-open');
            document.body.style.overflow = 'auto';
          }
        });
      });
    }
  }

  // Call the function to set up the event listeners when the page is ready
  document.addEventListener('DOMContentLoaded', addEventListenerToArticleSummary);

  jQuery('.modal-close, .modalCloseButton').on('click', () => {
    const modalContainerClose = jQuery('.modal-container');
    modalContainerClose.removeClass('is-open');
    jQuery('body').css('overflow', 'visible');
  });

  document.addEventListener('DOMContentLoaded', () => {
    const clipboard = new ClipboardJS('.modal__copy-button');
    const notification = document.querySelector('.copy-notification');
    const notificationDisplayTime = 2000;

    function openModal(modal) {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal(modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = 'auto';
    }

    addEventListenerToArticleSummary();

    clipboard.on('success', () => {
      notification.classList.add('open');
      setTimeout(() => {
        notification.classList.remove('open');
      }, notificationDisplayTime);
    });

    // Modal and image modal references
    const modalContainer = document.querySelector('.modal-container');
    const imageModal = document.querySelector('.image-modal');
    const modalBackdrop = document.querySelector('.modal-backdrop');
    const imageModalBackdrop = document.querySelector('.image-modal-backdrop');
    const closeButton = document.querySelector('.modal__close-button');

    // Open modal event listeners
    const openModalButtons = document.querySelectorAll('.open-modal');
    openModalButtons.forEach((button) => {
      button.addEventListener('click', () => {
        openModal(modalContainer);
      });
    });

    const openImageModalButtons = document.querySelectorAll('.open-image-modal');
    openImageModalButtons.forEach((button) => {
      button.addEventListener('click', () => {
        openModal(imageModal);
      });
    });

    // Close modal event listeners
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        closeModal(modalContainer);
      });
    }

    if (modalContainer) {
      modalContainer.addEventListener('click', (e) => {
        if (e.target === modalBackdrop) {
          closeModal(modalContainer);
        }
      });
    }

    if (imageModal) {
      imageModal.addEventListener('click', (e) => {
        if (e.target === imageModalBackdrop) {
          closeModal(imageModal);
        }
      });
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    // wp-block-app-editor-message-carousel
    const isSiteFemina = document.querySelector('body.femina');

    if (!isSiteFemina) {
      return;
    }

    const editorMessage = document.querySelector('.wp-block-app-editor-message-carousel');
    const btnClose = document.querySelector('.modal .modal-content .close');
    const section = document.querySelector('.wp-block-app-articles-section');

    if (!editorMessage || !btnClose || !section) {
      return;
    }

    editorMessage.addEventListener('click', () => {
      document.documentElement.style.overflow = "hidden";
      section.style.zIndex = 9999;
      section.style.position = 'relative';
    })

    btnClose.addEventListener('click', () => {
      document.documentElement.style.overflow = "";
      section.style.zIndex = '';
      section.style.position = '';
    })
  })
})();
